export const translations = {
    AGE: 'newUserRequirements-age',
    RESIDENCE: 'newUserRequirements-residence',
    IDENTITY: 'newUserRequirements-identity',
    PHONE: 'newUserRequirements-phone',
    NOT_BE_CLIENT: 'newUserRequirements-notBeClient',
    MORE_DETAILS: 'newUserRequirements-moreDetails',
    JOINT_HOLDERS: 'newUserRequirements-jointHolders',
};
